import { useEffect, useState } from 'react';

const FADE_DURATION_MS = 300;

function PageLoader({ onLoaded }) {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const finishLoading = () => {
      setIsFading(true);
      setTimeout(() => onLoaded?.(), FADE_DURATION_MS);
    };

    if (document.fonts?.ready) {
      document.fonts.ready.then(finishLoading);
    } else {
      finishLoading();
    }
  }, [onLoaded]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white transition-opacity duration-300 ease-out"
      style={{ opacity: isFading ? 0 : 1 }}
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-6">
        <div
          className="w-10 h-10 border-2 border-[#E5E5E5] border-t-[#0D0D0D] rounded-full"
          style={{ animation: 'pageLoaderSpin 0.8s linear infinite' }}
        />
        <p className="text-sm font-manrope text-[#999999]">Loading...</p>
      </div>
      <style>{`
        @keyframes pageLoaderSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default PageLoader;
